// extracted by mini-css-extract-plugin
export var formCloseButton = "formModal-module--formCloseButton--yo4aS";
export var formCloseIcon = "formModal-module--formCloseIcon--kEjc6";
export var formModal = "formModal-module--formModal--VlDQD";
export var page404Title = "formModal-module--page404-title--Psd7G";